import { clsx } from 'clsx';
/**
 * Combines multiple class names or conditional class expressions.
 */
export function cn(...inputs) {
    return clsx(inputs);
}
//# sourceMappingURL=utils.js.map